// extracted by mini-css-extract-plugin
module.exports = {"TooltipWrapper":"BasicTooltip_TooltipWrapper__lvHr2","TooltipTip":"BasicTooltip_TooltipTip__2FZE9"};